import { LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithoutRef, memo } from "react"

import { IconWrapper, type IconWrapperProps } from "./IconWrapper"

export interface LuIconWithWrapperProps
	extends Omit<IconWrapperProps, "children">, Pick<ComponentPropsWithoutRef<typeof LuIcon>, "icon"> {}

export const LuIconWithWrapper = memo<LuIconWithWrapperProps>((props) => {
	const { ref, icon, color, ...rest } = props

	return (
		<IconWrapper ref={ref} color={color} {...rest}>
			<LuIcon icon={icon} color={color ?? "var(--base-9)"} />
		</IconWrapper>
	)
})
LuIconWithWrapper.displayName = "LuIconWithWrapper"
